import { render, staticRenderFns } from "./EditarConsumo.vue?vue&type=template&id=489e8a20&scoped=true"
import script from "./EditarConsumo.vue?vue&type=script&lang=js"
export * from "./EditarConsumo.vue?vue&type=script&lang=js"
import style0 from "./EditarConsumo.vue?vue&type=style&index=0&id=489e8a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e8a20",
  null
  
)

export default component.exports